module.exports = __webpack_public_path__ + "img/avatar_default_4.aba6089c.svg";